import React from "react";
import { Link } from "react-router-dom";
import { Box, Button } from "@mui/material";
import { PageActions, PageBreadcrumbs, PageSubtitle, PageTitle } from "pages/Layouts/components/PageTitleContainer";
import { FullPagePaperLayout } from "pages/Layouts/FullPagePaperLayout";
import { LocationManagementLocationType } from "types/locationManagement/locationType";
import { RevivnDatabaseDataGrid } from "components/DataGrid/RevivnDatabaseDataGrid";
import { linkColDef } from "components/DataGrid/columnDefs/linkColDef";

const LocationTypeList: React.FC = () => {
  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Admin" }, { label: "Location Types", path: "/location-types" }]} />
      <PageTitle>Location Types</PageTitle>
      <PageSubtitle>
        Define the types of locations we allow in our facilities — set the structure, rules, and defaults for each
        location category. Ex: RESL
      </PageSubtitle>
      <PageActions>
        <Button variant="contained" color="primary" component={Link} to="/location-types/new">
          Create Location Type
        </Button>
      </PageActions>
      <RevivnDatabaseDataGrid
        url="/location_management/location_types"
        syncStateWithSearchParams
        columns={[
          { field: "id", headerName: "ID", width: 90 },
          {
            field: "name",
            headerName: "Location Type",
            width: 200,
            filterable: false,
            ...linkColDef<LocationManagementLocationType>(({ row }) => `/location-types/${row.id}/edit`),
          },
          {
            field: "labelColor",
            headerName: "Label color",
            width: 180,
            sortable: false,
            filterable: false,
            valueGetter: (params) => params.row.labelColor?.name ?? "",
            renderCell: (params) => {
              const color = params.row.labelColor;
              if (!color) return null;
              return (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box
                    sx={{
                      width: 16,
                      height: 16,
                      bgcolor: color.hex,
                      border: "1px solid",
                      borderColor: "divider",
                    }}
                  />
                  {color.name}
                </Box>
              );
            },
          },
        ]}
        pageSize={25}
      />
    </FullPagePaperLayout>
  );
};

export default LocationTypeList;
